import type { EmbedChannel } from '../types'

/** Default public base URL of the Journey app. */
export const DEFAULT_JOURNEY_APP_BASE_URL = 'https://journey.epilot.io'

/**
 * Returns the URL for the `<epilot-journey>` web component script.
 *
 * Resolution order:
 * 1. `webComponentScriptUrl` — explicit override (used in local dev)
 * 2. `${baseUrl}/${channel}/assets/embed.js`
 */
export const getWebComponentScriptUrl = (
  channel: EmbedChannel = 'stable',
  baseUrl: string = DEFAULT_JOURNEY_APP_BASE_URL,
  webComponentScriptUrl?: string
): string => {
  if (webComponentScriptUrl) return webComponentScriptUrl
  return `${baseUrl}/${channel}/assets/embed.js`
}
